var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useCallback, useContext } from 'react';
import { IconContext } from '@arco-design/web-react/icon/react-icon/context';
import { ConfigProvider } from '@arco-design/web-react';
export function ArcoIconWrapper(_a) {
  var Icon = _a.Icon,
    restProps = __rest(_a, ["Icon"]);
  var iconConfig = useContext(IconContext);
  return /*#__PURE__*/React.createElement(Icon, __assign({
    prefix: iconConfig.prefixCls
  }, restProps));
}
var positionList = [['left', 'right'], ['tl', 'tr'], ['bl', 'br'], ['lt', 'rt'], ['lb', 'rb']]; /** 兼容rtl模式 */
export function usePosition() {
  var rtl = useContext(ConfigProvider.ConfigContext).rtl;
  var idx = rtl ? 1 : 0;
  var nextIdx = (idx + 1) % 2;
  return useCallback(function (position) {
    return position.replace('start', positionList[0][idx]).replace('end', positionList[0][nextIdx]).replace('ts', positionList[1][idx]).replace('te', positionList[1][nextIdx]).replace('bs', positionList[2][idx]).replace('be', positionList[2][nextIdx]).replace('st', positionList[3][idx]).replace('et', positionList[3][nextIdx]).replace('sb', positionList[4][idx]).replace('eb', positionList[4][nextIdx]);
  }, [idx, nextIdx]);
}